import {FC, useState} from 'react';
import { useForm } from 'react-hook-form';
import { BsFillArrowRightCircleFill } from 'react-icons/bs';
import SimpleSpinner from '../../loaders/spinners/SimpleSpinner';

export type ContactUsFormData = {
    name: string,
    contact_number: string,
    subject: string,    
    message: string,    
};

type IContactUsFormProps = {
    isLoading: boolean,
    defaultFormData: ContactUsFormData,
    onSubmit: (data: ContactUsFormData) => void
};

const ContactUsForm: FC<IContactUsFormProps> = ({isLoading, defaultFormData, onSubmit}) => {
    const { register, handleSubmit, setValue } = useForm<ContactUsFormData>({defaultValues: defaultFormData});

    // evt handlers
    const onFormSubmit = (formData: ContactUsFormData) => {        
        onSubmit(formData);
    };

    return (<div className="w-3/4 lg:w-1/3 m-4 bg-gray-100 dark:bg-gray-700 shadow-lg rounded-lg flex items-center justify-center pb-12 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md space-y-8">
          <div>            
            <h2 className="text-gray-800 dark:text-gray-100 mt-6 text-center text-3xl font-bold tracking-tight">
              Reach out!
            </h2>
            <p className="text-gray-700 dark:text-gray-200 mt-2 text-center text-lg text-gray-600">
            Please find the details below. You can also fill the contact us form and we will get in touch with you. <br/><br/>
              <a href="https://www.powerministry.info" className="font-medium text-indigo-600 hover:text-indigo-500">
                Click here to visit our parent site
              </a>
            </p>
          </div>          
          <form className="mt-8 space-y-6" onSubmit={handleSubmit(onFormSubmit)}>                            
                  {/* First row */}
                  <div className="my-4">
                      <label htmlFor="form-name" className="sr-only">
                          Name
                      </label>
                      <input {...register('name')} id="form-name" type="text"  required                        
                          className="relative block w-full appearance-none rounded-md border 
                          border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 
                          focus:outline-none focus:ring-indigo-500 sm:text-sm"
                          placeholder="Your Name (Required)" />                      
                  </div>
                  {/* Second Row */}
                  <div className="my-4">
                      <label htmlFor="form-contact" className="sr-only">
                          Contact Number (Optional)
                      </label>
                      <input {...register('contact_number')} id="form-contact" type="text"                          
                          className="relative block w-full appearance-none rounded-md border 
                          border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 
                          focus:outline-none focus:ring-indigo-500 sm:text-sm"
                          placeholder="+60 11 123 2345 (Optional)" /> 
                  </div>
                  {/* Third Row */}
                  <div className="my-4">                      
                      <input {...register('subject')} id="form-subject" type="text" required
                          className="relative block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                          placeholder="Enter Title (Required)" />
                  </div>
                  {/* Fourth Row */}
                  <div className="my-4">                      
                      <textarea 
                    {...register('message')}
                    required
                    id="form-description"
                    rows={4}
                    cols={10}
                    className="appearance-none block w-full border-2 border-blue-200 dark:border-teal-700 bg-white text-gray-700 rounded py-3 px-4 mb-3 leading-tight focus:ring-indigo-500 focus:outline-none"
                    placeholder="State your question here...(Required)"/>
                  </div>              
                {/* Fifth Row */}
              <div>
                  <SimpleSpinner loading={isLoading} title={'Submitting form'}/>
                  <button
                        disabled={isLoading}                      
                        type="submit"
                      className="group relative flex w-full justify-center rounded-md border border-transparent
                                disabled:bg-gray-400 
                                bg-indigo-600 py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 
                                focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                          <BsFillArrowRightCircleFill className={`h-5 w-5 text-indigo-500 group-hover:text-indigo-400`}
                              aria-hidden="true" />
                      </span>
                      Submit Form
                  </button>
              </div>
          </form>
        </div>
      </div>);
};

export default ContactUsForm;
/*
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/